import React from 'react';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import PostData from '../../data/battles.json';

const DropdownOne = (props) => {
	const { buttonProps, itemProps, isOpen, setIsOpen } = useDropdownMenu(16);
	return (
		<React.Fragment>
			<div id="fix" className="battles">
				<button
					{...buttonProps}
					type='button'
					id='menu-button'>
					<span>Battles</span>
				</button>

				<div 
				className={isOpen ? 'visible' : ''} 
				role='menu' 
				id='menu'
				>
					{PostData.map((postDetail, index) => {
						return (
							<a
								{...itemProps[index]}
								onClick={() => { props.onPin(index); }}
								id={'menu-item-' + index}
								key={index}>
								{postDetail.title}
							</a>
						);
					})}
				</div>
			</div>
		</React.Fragment>
	);
};

export default DropdownOne;